import React, { PureComponent } from 'react';

import { Grid } from '@mui/material';

import { LoadingButton } from '../../utils';

import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { allBarcodesValid } from '../../../barcodes';
import { getCurrentMission } from '../../../dataModelHelpers';
import download from 'downloadjs';
import { alertConfirmDownload } from '../helpers/downloads';
import { cancelConfirmTag, alertError, alertWarn } from '../../../alertDispatcher';

interface DownloadCSVButtonProps {}

export default class DownloadCSVButton extends PureComponent<DownloadCSVButtonProps> {
  constructor(props: DownloadCSVButtonProps) {
    super(props);

    this.downloadCSV = this.downloadCSV.bind(this);
  }

  componentWillUnmount() {
    cancelConfirmTag(this.constructor.name);
  }

  async downloadCSV() {
    try {
      if (allBarcodesValid() || (await alertConfirmDownload(this.constructor.name))) {
        const mission = getCurrentMission();

        if (!mission) {
          alertError('No mission available');

          return;
        }

        const csvs = await mission.generate_lab_csvs();

        if (!csvs || csvs.length === 0) {
          alertError('Could not export CSV');

          return;
        }

        // Surface validation issues but let the technician proceed.
        const errors = csvs.flatMap((c) => c.errors);

        if (errors.length > 0) {
          alertWarn(`CSV generated with ${errors.length} warning(s):\n${errors.slice(0, 20).join('\n')}`);
        }

        // One file per spec/deal, under the cloud-generated filename.
        csvs.forEach((c) => download(c.toString(), c.filename, 'text/csv'));
      }
    } catch (err) {
      console.error('Could not export CSV', err);
    }
  }

  render() {
    return (
      <Grid>
        <LoadingButton variant="outlined" onClick={this.downloadCSV} data-testid="mission-download-csv">
          <CloudDownloadIcon style={{ paddingRight: 7.5 }} />
          CSV
        </LoadingButton>
      </Grid>
    );
  }
}
